import { Map } from 'immutable';

import ReviewFormTemplates from 'Shared/constants/ReviewFormTemplates.constants';

export const getFormType = form => {
  if (!Map.isMap(form)) {
    return false;
  }
  return form.get(ReviewFormTemplates.Model.FORM_TYPE);
};

export const getQuestions = form => {
  if (!Map.isMap(form)) {
    return false;
  }
  return form.get(ReviewFormTemplates.Model.QUESTIONS, []);
};

export const getQuestionKey = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.KEY);
};

export const getQuestionVisibility = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.VISIBILITY);
};

export const getQuestionType = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.TYPE);
};

export const getQuestionProperty = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.PROPERTY);
};

export const getQuestionNegativeAdjectives = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.getIn([ReviewFormTemplates.Model.ADJECTIVES, ReviewFormTemplates.Model.NEGATIVE]);
};

export const getQuestionPositiveAdjectives = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.getIn([ReviewFormTemplates.Model.ADJECTIVES, ReviewFormTemplates.Model.POSITIVE]);
};

export const getSummarizedQuestionKey = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.SUMMARIZED_QUESTION_KEY);
};

export const getQuestionHeader = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.HEADER);
};

export const getQuestionOptional = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.OPTIONAL);
};

export const getQuestionDescription = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.DESCRIPTION);
};

export const getQuestionSelfReviewDescription = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.SELF_REVIEW_DESCRIPTION);
};

export const getQuestionPlaceholder = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.PLACEHOLDER);
};

export const getQuestionPrivate = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.PRIVATE);
};

export const getQuestionExplanationDescription = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.EXPLANATION_DESCRIPTION);
};

export const getQuestionShowExplanation = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.SHOW_EXPLANATION);
};

export const getValues = question => {
  if (!Map.isMap(question)) {
    return false;
  }
  return question.get(ReviewFormTemplates.Model.VALUES, []);
};
